import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { ScaleBarNotifier } from './scale-bar-notifier';
import { ScaleBarState } from './scale-bar-state';

@Injectable()
export class ScaleBarProvider extends BaseProvider<ScaleBarNotifier, ScaleBarState> {
  constructor() {
    super(ScaleBarNotifier);
  }
}
